export default "__VITE_ASSET__be07bd52__"